export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-3.910fe552.png";